import { hasMinAgeAtLicenseDate, hasMinLicenseYears, getAgeInYears } from 'helpers/date';

export const validateClientAge = (operator, birthDate, ageThreshold) => {
  const ages = getAgeInYears(birthDate);

  if (operator === 'between') {
    if (ageThreshold.length !== 2)
      throw new Error(
        'El validador de fecha "between" debe tener 2 parámetros. min, max. Ejemplo: client_age_between:22,70'
      );

    const [min, max] = ageThreshold;
    return ages >= parseInt(min, 10) && ages < parseInt(max, 10);
  }

  return false;
};

export const validateDriverLicenseAge = (operator, licenseDate, args) => {
  const MIN_AGE = 18;
  const BIRTH_DATE = args[0];
  const MIN_LICENSE_YEARS = args[1];

  const isValidAge = hasMinAgeAtLicenseDate(BIRTH_DATE, licenseDate, MIN_AGE);
  const isValidLicense = hasMinLicenseYears(licenseDate, MIN_LICENSE_YEARS);

  if (operator === 'ge') {
    return isValidAge && isValidLicense;
  }

  return false;
};
